import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { PermissionValue, UserType } from "../../utils/enums";
import { UserSessionResponse } from "../../utils/interfaces";

@Injectable({
  providedIn: "root"
})
export class VendorGuard implements CanActivate {
  constructor(
    private router: Router
  ) { }

  canActivate(): boolean {
    if (
      localStorage.getItem("intrasense-user:session") &&
      localStorage.getItem("intrasense-user:token")
    ) {
      let user: UserSessionResponse = JSON.parse(
        localStorage.getItem("intrasense-user:session") as string
      );
      if (user.user_type == UserType.VENDOR && user.can_create == false && user.can_approve == false && user.can_view == false && user.can_support == false) {
        return true;
      } else {
        this.router.navigate(["/error/401"]);
        return false;
      }
    } else if (
      sessionStorage.getItem("intrasense-user:session") &&
      sessionStorage.getItem("intrasense-user:token")
    ) {
      let user: UserSessionResponse = JSON.parse(
        sessionStorage.getItem("intrasense-user:session") as string
      );
      if (user.user_type == UserType.VENDOR && user.can_create == false && user.can_approve == false && user.can_view == false && user.can_support == false) {
        return true;
      } else {
        this.router.navigate(["/error/401"]);
        return false;
      }
    } else {
      this.router.navigate(["/"]);
      return false;
    }
  }
}

@Injectable({
  providedIn: "root"
})
export class NotVendorGuard implements CanActivate {
  constructor(
    private router: Router
  ) { }

  canActivate(): boolean {
    if (
      localStorage.getItem("intrasense-user:session") &&
      localStorage.getItem("intrasense-user:token")
    ) {
      let user: UserSessionResponse = JSON.parse(
        localStorage.getItem("intrasense-user:session") as string
      );
      if (user.user_type && user.user_type == UserType.USER) {
        return true;
      } else {
        this.router.navigate(["/error/401"]);
        return false;
      }
    } else if (
      sessionStorage.getItem("intrasense-user:session") &&
      sessionStorage.getItem("intrasense-user:token")
    ) {
      let user: UserSessionResponse = JSON.parse(
        sessionStorage.getItem("intrasense-user:session") as string
      );
      if (user.user_type && user.user_type == UserType.USER) {
        return true;
      } else {
        this.router.navigate(["/error/401"]);
        return false;
      }
    } else {
      this.router.navigate(["/"]);
      return false;
    }
  }
}